import { createFileRoute } from '@tanstack/react-router'
import { ModuleGate } from '@/components/module-gate'

export const Route = createFileRoute('/_authed/pos')({
  component: () => (
    <ModuleGate moduleKey="pos">
      <PosReports />
    </ModuleGate>
  ),
})

function PosReports() {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold">POS Reports</h2>
      <p className="mt-2 text-muted-foreground">Coming in Phase 1e.</p>
    </div>
  )
}
